import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { GlobalService } from '../../global/global.service';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Login } from './login-object.model';

@Injectable()

export class AuthService {

  // store the URL so we can redirect after logging in

  constructor(private http: HttpClient, private globalService: GlobalService) {
  }

  url2 = this.globalService.urlContaE();
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  getToken() {
    return localStorage.getItem('key');
  }



  postHeader(json) {
    return {
      headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
    };
  }


  public aceptTerms(Id_Contract): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Contract: Id_Contract
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.url2 + 'api/User/Contract_Accepted', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.message);
      });
  }

  public signedContract(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.url2 + 'api/User/Contract_Signed', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.message);
      });
  }

  public terms(): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(this.url2 + 'api/User/Contract_Show', '', {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.message);
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/authentication/login/auth.service.ts